module.exports = __webpack_public_path__ + "img/pic_face_woman@2x.c455e46f.png";